import React, { useEffect, useState } from "react"
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    Autocomplete,
    Typography
} from "@mui/material"
import { Controller, useForm } from "react-hook-form"
import apiUrl from '../../configs/constant';
import axios from 'axios'
import { useToast } from "../ToastProvider";
interface Props {
    open: boolean
    jenis: any
    onClose: () => void
}

export default function DialogTambahBiaya({
    open,
    jenis,
    onClose
}: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();
    const [listWO, setListWO] = useState<any[]>([])
    const [listAkun, setListAkun] = useState<any[]>([])
    const [listAkunBiaya, setListAkunBiaya] = useState<any[]>([])
    const [listProfitCenter, setListProfitCenter] = useState<any[]>([])

    const today = new Date();
    const tglToday = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

    const getWo = () => {
        setListWO([])
        let url = apiUrl.apiUrl + '/production/jasa-work-order/list'

        axios
            .get(url, {
                params: {
                    awal: '2025-01-01',
                    akhir: '2999-01-01',
                    mode: 0,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListWO(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getAkun = () => {
        setListAkun([])
        let url = apiUrl.apiUrl + '/production/jasa-work-order/list-rekening-bank'

        axios
            .get(url, { headers: { Authorization: `Bearer ${token}` } })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListAkun(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getAkunBiaya = () => {
        setListAkunBiaya([])
        let url = apiUrl.apiUrl + '/production/jasa-work-order/list-biaya'

        axios
            .get(url, { headers: { Authorization: `Bearer ${token}` } })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListAkunBiaya(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getProfitCenter = () => {
        setListProfitCenter([])
        let url = apiUrl.apiUrl + '/acc/penyesuaian/list-profit-center'

        axios
            .get(url, { headers: { Authorization: `Bearer ${token}` } })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListProfitCenter(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    useEffect(() => {
        if (!open) return
        reset();
        getWo();
        getAkun();
        getAkunBiaya();
        getProfitCenter();
        setValue('jenis', jenis);
    }, [open])

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        reset,
        watch
    } = useForm({
        defaultValues: {
            wo_order_id: null,
            accakun_bank_id: null,
            accakun_id: null,
            accprofitcenter_id: null,
            tgl: tglToday,
            keterangan: null,
            total: null,
            jenis: null,
            total_biaya: null,
            sudah_dicairkan: null
        }
    })

    const onSubmit = (payload: any) => {
        const payloadFinal = {
            ...payload,
            accakun_bank_id: payload.accakun_bank_id?.id || null,
            accakun_id: payload.accakun_id?.id || null,
            wo_order_id: payload.wo_order_id?.id || null,
            accprofitcenter_id: payload.accprofitcenter_id?.id || null
        };

        const url = apiUrl.apiUrl + '/production/jasa-work-order/save-pencairan';
        axios.post(url, payloadFinal, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            showToast(res.data.message, 'success');
            onClose();
        });
    };

    const formatNumber = (value: string | number) => {
        if (!value) return "";

        const str = String(value);

        // split decimal
        const [int, dec] = str.replace(/\./g, "").split(",");

        const formattedInt = Number(int || 0).toLocaleString("id-ID");

        return dec !== undefined ? `${formattedInt},${dec}` : formattedInt;
    };

    const parseNumber = (value: string) => {
        return value.replace(/\./g, "");
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle sx={{ textAlign: 'center' }}>
                    TAMBAHAN BIAYA JASA WO <br />
                    {jenis}
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>

                        {/* Tanggal */}
                        <Grid item xs={12}>
                            <Controller
                                name="tgl"
                                control={control}
                                defaultValue={new Date().toISOString().slice(0, 10)}
                                rules={{ required: "Tanggal wajib diisi" }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        type="date"
                                        label="Tanggal"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        error={!!errors.tgl}
                                        helperText={errors.tgl?.message as string}
                                    />
                                )}
                            />
                        </Grid>

                        {/* WO ORDER */}
                        <Grid item xs={12}>
                            <Controller
                                name="wo_order_id"
                                control={control}
                                rules={{ required: "WO Order wajib dipilih" }}
                                render={({ field }) => (
                                    <Autocomplete
                                        {...field}
                                        value={field.value || null}
                                        options={listWO}
                                        isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                                        getOptionLabel={(o) => `${o?.kode ?? ""} | ${o?.qty ?? ""}`}
                                        filterOptions={(options, { inputValue }) => {
                                            const search = (inputValue || "").toLowerCase();

                                            return options.filter((opt) => {
                                                const kode = String(opt?.kode || "").toLowerCase();
                                                const id = String(opt?.id || "").toLowerCase();

                                                return kode.includes(search) || id.includes(search);
                                            });
                                        }}
                                        onChange={(_, val) => {
                                            field.onChange(val)
                                            if (jenis == "POTONG") {
                                                setValue('total_biaya', (val.qty * val.harga_potong) - val.cair_potong)
                                                setValue('sudah_dicairkan', val.cair_potong)
                                            } else if (jenis == "JAHIT") {
                                                setValue('total_biaya', (val.qty * val.harga_jahit) - val.cair_jahit)
                                                setValue('sudah_dicairkan', val.cair_jahit)
                                            } else if (jenis == "BORDIR") {
                                                setValue('total_biaya', (val.qty * val.harga_bordir) - val.cair_bordir)
                                                setValue('sudah_dicairkan', val.cair_bordir)
                                            } else if (jenis == "LAINNYA") {
                                                setValue('total_biaya', 0)
                                            }

                                            setValue('total', getValues('total_biaya'))
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="WO Order"
                                                error={!!errors.wo_order_id}
                                                helperText={errors.wo_order_id?.message as string}
                                            />
                                        )}
                                    />
                                )}
                            />
                        </Grid>

                        {/* AKUN BANK */}
                        <Grid item xs={12}>
                            <Controller
                                name="accakun_bank_id"
                                control={control}
                                rules={{ required: false }}
                                render={({ field }) => (
                                    <Autocomplete
                                        {...field}
                                        value={field.value || null}
                                        options={listAkun}
                                        isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                                        getOptionLabel={(o) => `${o?.id ?? ""} | ${o?.nama ?? ""}`}
                                        filterOptions={(options, { inputValue }) => {
                                            const search = (inputValue || "").toLowerCase();

                                            return options.filter((opt) => {
                                                const id = String(opt?.id || "").toLowerCase();
                                                const nama = String(opt?.nama || "").toLowerCase();

                                                return id.includes(search) || nama.includes(search);
                                            });
                                        }}
                                        onChange={(_, val) => field.onChange(val)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Akun Bank"
                                                error={!!errors.accakun_bank_id}
                                                helperText={errors.accakun_bank_id?.message as string}
                                            />
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name="accakun_id"
                                control={control}
                                rules={{ required: "Akun Biaya wajib dipilih" }}
                                render={({ field }) => (
                                    <Autocomplete
                                        {...field}
                                        value={field.value || null}
                                        options={listAkunBiaya}
                                        isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                                        getOptionLabel={(o) => `${o?.id ?? ""} | ${o?.nama ?? ""} | Saldo: ${o?.saldo ?? 0}`}
                                        filterOptions={(options, { inputValue }) => {
                                            const search = (inputValue || "").toLowerCase();

                                            return options.filter((opt) => {
                                                const id = String(opt?.id || "").toLowerCase();
                                                const nama = String(opt?.nama || "").toLowerCase();
                                                const saldo = String(opt?.saldo || "").toLowerCase();

                                                return id.includes(search) || nama.includes(search) || saldo.includes(search);
                                            });
                                        }}
                                        onChange={(_, val) => field.onChange(val)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Akun Biaya"
                                                error={!!errors.accakun_id}
                                                helperText={errors.accakun_id?.message as string}
                                            />
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name="accprofitcenter_id"
                                control={control}
                                rules={{ required: "Profit Center wajib dipilih" }}
                                render={({ field }) => (
                                    <Autocomplete
                                        {...field}
                                        value={field.value || null}
                                        options={listProfitCenter}
                                        isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                                        getOptionLabel={(o) => o?.nama_profitcenter ?? ""}
                                        onChange={(_, val) => field.onChange(val)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Profit Center"
                                                error={!!errors.accprofitcenter_id}
                                                helperText={errors.accprofitcenter_id?.message as string}
                                            />
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} hidden>
                            <Controller
                                name="sudah_dicairkan"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Sudah Dicairkan"
                                        fullWidth
                                        value={formatNumber(field.value || "0")}
                                        InputProps={{ readOnly: true }}
                                        onChange={(e) => field.onChange(parseNumber(e.target.value))}
                                        error={!!errors.sudah_dicairkan}
                                        helperText={errors.sudah_dicairkan?.message as string}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} hidden>
                            <Controller
                                name="total_biaya"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Sisa Total Biaya"
                                        fullWidth
                                        value={formatNumber(field.value || "0")}
                                        InputProps={{ readOnly: true }}
                                        onChange={(e) => field.onChange(parseNumber(e.target.value))}
                                        error={!!errors.total_biaya}
                                        helperText={errors.total_biaya?.message as string}
                                    />
                                )}
                            />
                        </Grid>
                        {/* TOTAL */}
                        <Grid item xs={12}>
                            <Controller
                                name="total"
                                control={control}
                                rules={{
                                    required: "Total wajib diisi",
                                    validate: (value) => {
                                        const total = Number(value || 0);
                                        const totalBiaya = Number(getValues("total_biaya") || 0);

                                        if (!total || total === 0) {
                                            return "Total tidak boleh 0";
                                        }

                                        // if (jenis != "LAINNYA" && jenis != "BORDIR") {
                                        //     if (total > totalBiaya) {
                                        //         return "Nominal Pencairan tidak boleh lebih besar dari total biaya";
                                        //     }
                                        // }
                                        return true;
                                    }
                                }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Nominal"
                                        fullWidth
                                        value={formatNumber(field.value || "0")}
                                        inputProps={{ inputMode: "numeric" }}
                                        onChange={(e) => field.onChange(parseNumber(e.target.value))}
                                        error={!!errors.total}
                                        helperText={errors.total?.message as string}
                                    />
                                )}
                            />
                        </Grid>

                        {/* KETERANGAN */}
                        <Grid item xs={12}>
                            <Controller
                                name="keterangan"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label="Keterangan"
                                        fullWidth
                                        multiline
                                        rows={3}
                                        error={!!errors.keterangan}
                                        helperText={errors.keterangan?.message as string}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions sx={{ p: 2 }}>
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                    >
                        SIMPAN PENCAIRAN
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}